import SignInPage from '../js/screens/SignInPage/SignInPage';
import About from '../js/screens/About/About';
import Account from '../js/screens/Account/Account';
import SearchPortal from '../js/screens/SearchPortal/SearchPortal';
import SearchResults from '../js/screens/SearchResults/SearchResults';
import YourActivity from '../js/screens/YourActivity/YourActivity';
//import Bookmarks from '../js/screens/Bookmarks/Bookmarks';
import TermsOfService from '../js/screens/LegalPages/TermsOfService';
import PrivacyPolicy from '../js/screens/LegalPages/PrivacyPolicy';
import AboutUs from '../js/screens/AboutUs/AboutUs';
import Careers from '../js/screens/Careers/Careers';
import SecurityPractices from '../js/screens/LegalPages/SecurityPractices';
import HowItWorksPage from '../js/screens/HowItWorksPage/HowItWorksPage';
import PublicBeta from '../js/screens/PublicBeta/PublicBeta';
import Gtc from '../js/screens/GTC/Gtc';

export interface RouteProps{
  path: string,
  exact: boolean,
  private: boolean,
  children: Element[],
}

const routes = [
// public routes
  {
    path: '/',
    exact: true,
    private: false,
    children: [
      <About />
    ]
  }, {
    path: '/about',
    exact: false,
    private: false,
    children: [
      <About />
    ]
  }, {
    path: '/about-us',
    exact: false,
    private: false,
    children: [
      <AboutUs />
    ]
  }, {
    path: '/careers',
    exact: false,
    private: false,
    children: [
      <Careers />
    ]
  }, {
    path: '/signin-beta',
    exact: false,
    private: false,
    children: [
      <PublicBeta />
    ]
  }, {
    path: '/signin',
    exact: false,
    private: false,
    children: [
      <SignInPage />
    ]
  }, {
    path: '/tos',
    exact: false,
    private: false,
    children: [
      <TermsOfService />
    ]
  }, {
    path: '/privacy',
    exact: false,
    private: false,
    children: [
      <PrivacyPolicy />
    ]
  }, {
    path: '/security',
    exact: false,
    private: false,
    children: [
      <SecurityPractices />
    ]
  }, {
    path: '/how-it-works',
    exact: false,
    private: false,
    children: [
      <HowItWorksPage />
    ]
  }, {
    path: '/searchportal',
    exact: false,
    private: false,
    children: [
      <SearchPortal />
    ]
  },
  // private routes
  // remove bookmarks until further notice
  /*{
    path: '/bookmarks',
    exact: false,
    private: true,
    children: [
      <Bookmarks />
    ]
  },*/ {
    path: '/youractivity',
    exact: false,
    private: true,
    children: [
      <YourActivity />
    ]
  }, {
    path: '/searchresults',
    exact: false,
    private: true,
    children: [
      <SearchResults />
    ]
  }, {
    path: '/account',
    exact: false,
    private: true,
    children: [
      <Account />
    ]
  }, {
    path: '/gtc',
    exact: true,
    private: true,
    children: [
      <Gtc />
    ]
  }
];

export default routes;